define('SageDotCom/DataLayer/Global/generic-video-tracker',[
    "jquery",
    "SageDotCom/DataLayer/Events/video-interaction"
],
function ($, VideoInteractionEvent) {

    // Possible milestones
    var milestones = [0, .25, .5, .75, 1];

    function GenericVideoTracker() {
    }

    function getCurrentMilestone(player) {
        var elapsedTime = player.currentTime / player.duration;

        // Get milestone index that matches elapsed time
        var milestone = _.findLastIndex(milestones, function (m) { return elapsedTime >= m; });

        return milestone;
    }

    function trackMilestoneEvents() {
        var milestone = getCurrentMilestone(this);
        var lastMilestone = this.tracking.milestone != undefined ? this.tracking.milestone : -1;
        
        // Raise analytics event if new milestone reached
        if (milestone > lastMilestone) {
            this.tracking.milestone = milestone;
            new VideoInteractionEvent(this, true).trigger();
        }
    }

    function onPlay() {
        this.tracking.milestoneIntervalId = setInterval(trackMilestoneEvents.bind(this), 500);
        this.tracking.eventType = "play";
        new VideoInteractionEvent(this).trigger();
    }

    //When the video is paused or ends
    function onPause() {
        var milestone = getCurrentMilestone(this);

        if (milestones[milestone] === 1) {
            //video has ended
            this.tracking.milestone = milestone;
            new VideoInteractionEvent(this, true).trigger();
            this.tracking.eventType = "end";
        } else {
            //video was paused
            this.tracking.eventType = "pause";
        }
        new VideoInteractionEvent(this).trigger();
        clearInterval(this.tracking.milestoneIntervalId);
    }

    function trackVideosIn(container) {
        // only set up tracking on video tags that are not inside a score brightcove video component
        var players = $(container).find("video").not(function () {
            return $(this).parents(".score-brightcove-video") !== null && $(this).parents(".score-brightcove-video").length > 0;
        });

        players.each(function (index, player) {
            if (player) {
                player.isYoutube = false;
                player.tracking = player.tracking || {};
                player.tracking.id = player.id;
                player.tracking.title = player.title;
                $(player).on("play", onPlay);
                $(player).on("pause", onPause);
            }
        });
    }

    GenericVideoTracker.prototype.start = function () {
        // Track state of all youtube players when youtube api loaded
        $(function () {
            trackVideosIn(document.body);
        });
    }

    return GenericVideoTracker;
});
